import GoogleMapsConverter from "@churchofjesuschrist/maps-google-converter";
import {getOverlayBounds} from "@churchofjesuschrist/maps-google-overlays";
import {GeometryType, LocationType} from "@churchofjesuschrist/maps-service";

export default function OrgService($http, $q, env, google, MapService, utils) {
	"ngInject";

	const compileBoundaries = (orgs) => (
		MapService.loadMapsApi().then(() => {
			utils.toArray(orgs).forEach((org) => {
				if (org.boundary) {
					let boundary = GoogleMapsConverter.convertFromMultiPolygon(org.boundary);
					boundary = angular.isArray(boundary) ? boundary[0] : boundary;
					if (boundary) {
						org.boundary = boundary;
						org.bounds = getOverlayBounds(org.boundary);
						org.label = null;	//label will need to be reset
					}
				}
			});
			return orgs;
		})
	);

	return {
		getMissionOrgs: (missionId) => (
			$http.get(`${env.apiUrl}/orgs`).then((response) => {
				let orgs = response.data;
				return compileBoundaries(orgs);
			})
		),
		getMissionAreas: (missionId, areaIds) => (
			$http.get(`${env.apiUrl}/orgs`, {params: {areas: areaIds}}).then((response) => {
				let areas = response.data;
				return compileBoundaries(areas);
			})
		),
		updateArea: (area) => {
			let dto = {
				id: area.id,
				type: area.type,
				name: area.name,
				referrals: area.referrals,
				assigned: area.assigned
			};
			return $http.put(`${env.apiUrl}/areas/${area.id}`, dto).then((response) => {
				let area = response.data;
				return compileBoundaries(area);
			});
		},
		updateAreaBoundary: (areaId, units, reset) => {
			let location = {id: areaId, type: LocationType.TEACHING_AREA, associated: [], boundary: null};
			if (units) {
				let coordinates = [];
				units.forEach((unit) => {
					let polygons = GoogleMapsConverter.convertToMultiPolygon(unit.boundary);
					polygons.coordinates.forEach((polygon) => {
						coordinates.push(polygon);
						location.associated.push({id: unit.id});
					});
				});
				location.boundary = {type: GeometryType.MULTI_POLYGON, coordinates};
			}
			return $http.put(`${env.apiUrl}/areas/${areaId}/boundary`, location, {params: {reset}}).then((response) => {
				let area = response.data;
				return compileBoundaries(area);
			});
		},
		updateAreaBoundaryStatus: (areaId, status) => (
			$http.post(`${env.apiUrl}/areas/${areaId}/boundary/status`, null, {params: {status}}).then((response) => {
				let area = response.data;
				return compileBoundaries(area);
			})
		),
		getCurrentEcclUnits: (ecclUnitOrgNumberOrphan, assignedFormatted) => {
			let ecclUnits = [];
			if (ecclUnitOrgNumberOrphan && Array.isArray(assignedFormatted)) {
				ecclUnits = assignedFormatted.map(af => {
					return {
						id: af.id,
						name: `${af.name} (${af.id})`,
						count: ecclUnitOrgNumberOrphan[af.id] || 0
					}
				})
			}
			return ecclUnits;
		},
		getEcclUnitsDeleted: (originalAssigned, assignedFormatted) => {
			let ecclUnitsDeleted = [];
			if (Array.isArray(originalAssigned) && Array.isArray(assignedFormatted)) {
				let assigned = assignedFormatted.map(af => af.id);
				ecclUnitsDeleted = originalAssigned.filter(oa => assigned.indexOf(oa) < 0);
			}
			return ecclUnitsDeleted;
		},
		getEcclUnitsDeletedOrphanInfo: (ecclUnitsDeleted, originalEcclUnitsWithOrphanCounts) => {
			let ecclUnitsDeletedOrphanInfo = [];
			if (Array.isArray(ecclUnitsDeleted) && Array.isArray(originalEcclUnitsWithOrphanCounts)) {
				ecclUnitsDeletedOrphanInfo = originalEcclUnitsWithOrphanCounts.filter(oeuwoc => {
					return oeuwoc.count > 0 && ecclUnitsDeleted.indexOf(oeuwoc.id) >= 0;
				});
			}
			return ecclUnitsDeletedOrphanInfo;
		}
	};
}
